import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCTAClick = () => {
    window.dispatchEvent(new Event('openInvitationForm'));
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 bg-white transition-all duration-300 ${scrolled ? 'shadow-md' : 'shadow-sm'}`}>
      <div className="w-full px-6 lg:px-12 py-1">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/f30444846e2254d95b405efc135ce378/c09e442e01e390b5cc043799528703e8.png"
              alt="Vetuvia Logo"
              width={56}
              height={56}
              fetchPriority="high"
              className="h-14 w-auto object-contain"
            />
            <span className="text-xl font-bold tracking-widest text-[#0A1628] uppercase">VETUVIA</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/about"
              className={`text-sm font-semibold transition-colors cursor-pointer hover:text-[#4DB8D4] ${
                location.pathname === '/about' ? 'text-[#4DB8D4]' : 'text-gray-700'
              }`}
            >
              About Us
            </Link>
            <a
              href="#how-it-works"
              className="text-sm font-semibold text-gray-700 hover:text-[#4DB8D4] transition-colors cursor-pointer"
            >
              How It Works
            </a>
            <Link
              to="/pricing"
              className={`text-sm font-semibold transition-colors cursor-pointer hover:text-[#4DB8D4] ${
                location.pathname === '/pricing' ? 'text-[#4DB8D4]' : 'text-gray-700'
              }`}
            >
              Pricing
            </Link>
            <a
              href="#faq"
              className="text-sm font-semibold text-gray-700 hover:text-[#4DB8D4] transition-colors cursor-pointer"
            >
              FAQ
            </a>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button
              onClick={handleCTAClick}
              className="px-6 py-2.5 rounded-full font-semibold text-sm bg-[#4DB8D4] hover:bg-[#3aa8c4] text-white shadow-md transition-all whitespace-nowrap cursor-pointer"
            >
              Request Invitation
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-gray-700"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3 border-t border-gray-100 pt-4">
            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-[#4DB8D4] transition-colors cursor-pointer"
            >
              About Us
            </Link>
            <a
              href="#how-it-works"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-[#4DB8D4] transition-colors cursor-pointer"
            >
              How It Works
            </a>
            <Link
              to="/pricing"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-[#4DB8D4] transition-colors cursor-pointer"
            >
              Pricing
            </Link>
            <a
              href="#faq"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-[#4DB8D4] transition-colors cursor-pointer"
            >
              FAQ
            </a>
            <button
              onClick={() => {
                handleCTAClick();
                setMobileMenuOpen(false);
              }}
              className="w-full px-6 py-2.5 bg-[#4DB8D4] hover:bg-[#3aa8c4] text-white rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              Request Invitation
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
